<h5 translate>agent-index.component.live-sessions</h5>
<lv-claims-list [sessions]="onlineIdSessions$ | async"></lv-claims-list>

<hr />

<h5 translate>agent-index.component.offline-sessions</h5>
<lv-claims-list [sessions]="offlineIdSessions$ | async"></lv-claims-list>

<hr />

<h5 translate>agent-index.component.retaken-sessions</h5>
<lv-claims-list [sessions]="retakenSessions$ | async" claimItemType="retakeRequest"></lv-claims-list>
